<script>
export default {
    name: "DischargedPatients",

    data() {

        return {
            dischargeTypes: [],
            patients: [],
            filter: {
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
                typeID: 0,
                search: ``,
            },
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchDischargeTypes(), this.fetchPatientsByFilters(), ]);
    },

    methods: {


      fetchDischargeTypes() {

          return this.$http.get(`Inpatient/GetDischargeTypes`).then(response => {
              this.dischargeTypes = response.data;
          }).catch(() => {});
      },

      fetchPatientsBySearch() {
          if(!this.filter.search) return;
          let url = `Admissions/GetDischargedPatientsforSearch`;
          url += this.filter.search ? `?SearchText=${this.filter.search}` : ``;
          this.$root.loading = true;
          this.$http.get(url).then(response => {
              this.patients = response.data;
              this.$root.loading = false;
          }).catch(() => { this.$root.loading = false; });
      },

      fetchPatientsByFilters() {
          if(!this.filter.dateFrom || !this.filter.dateTo) return;

          this.$root.loading = true;

          let url = `Admissions/GetDischargedPatientsforDateType`;
              url += `?DateFrom=${this.filter.dateFrom}`;
              url += `&DateTo=${this.filter.dateTo}`;
              url += `&Type=${this.filter.typeID}`;

          this.$http.get(url).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
      },
  },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                  <h5 class="font-semibold text-sm">Discharged Patients</h5>
              </template>
              <template v-slot:card-body>
                  <div class="w-full sm:max-w-xs md:max-w-none overflow-auto max-h-screen">
                        <div class="w-full flex md:flex-row sm:flex-col">
                            <div class="md:w-1/4 sm:w-full p-tiny">
                                <label for="grid-search" class="label-control">Search:</label>
                                <input type="text" @keydown.enter="fetchPatientsBySearch" 
                                    v-model.trim="filter.search" class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="md:w-1/4 sm:w-full p-tiny">
                                <label for="grid-date-from" class="label-control">Date from:</label>
                                <input type="date" v-model.trim="filter.dateFrom" 
                                    id="grid-date-from" class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="md:w-1/4 sm:w-full p-tiny">
                                <label for="grid-date-to" class="label-control">Date to:</label>
                                <input type="date" v-model.trim="filter.dateTo" 
                                    id="grid-date-to" class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="md:w-1/4 sm:w-full p-tiny">
                                <label for="grid-type" class="label-control">Type:</label>
                                <tail-select>
                                    <template v-slot:field>
                                        <select v-model="filter.typeID" id="grid-type" 
                                            class="input-control input-sm text-sm">
                                            <option :value="0">Select type</option>
                                            <option v-for="(dischargeType,idx) in dischargeTypes" 
                                                :key="idx" :value="dischargeType.id">{{ dischargeType.type }}</option>
                                        </select>
                                    </template>
                                </tail-select>
                            </div>
                            <div class="md:w-1/4 sm:w-full p-tiny">
                                <button 
                                    class="btn-sm btn-primary text-sm mt-4 rounded" 
                                    @click.prevent="fetchPatientsByFilters"><i class="fa fa-search"></i> Filter</button>
                            </div>
                        </div>
                        <table class="table">
                            <thead class="bg-blue-500 text-sm">
                                <tr class="flex text-white w-full">
                                    <th class="p-tiny w-1/3">Name</th>
                                    <th class="p-tiny w-1/12">OP No</th>
                                    <th class="p-tiny w-1/12">IP NO</th>
                                    <th class="p-tiny w-1/12">Bed Type</th>
                                    <th class="p-tiny w-1/6">Date</th>
                                    <th class="p-tiny w-1/6">Cover</th>
                                    <th class="p-tiny w-1/12">Select</th>
                                </tr>
                            </thead>
                            <tfoot>
                                <tr class="w-full flex">
                                    <td colspan="6" class="p-tiny w-full text-right">
                                        <h5 class="font-bold">Total Discharged: {{ patients.length }}</h5>
                                    </td>
                                </tr>
                            </tfoot>
                            <tbody class="text-sm font-semibold bg-gray-100 flex flex-col items-center overflow-auto w-full" 
                                style="height: 67vh;">
                                <tr class="flex w-full" v-for="(pat, idx) in patients" :key="idx">
                                    <td class="p-tiny w-1/3">
                                        <h5 class="text-sm text-gray-900">{{ pat.names }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">MRN: {{ pat.patientID }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">DOB: {{ pat.dob | dateFormat }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">Gender: {{ pat.gender }}</h5>
                                    </td>
                                    <td class="p-tiny w-1/12">{{ pat.opfileno }}</td>
                                    <td class="p-tiny w-1/12">{{ pat.ipfileno }}</td>
                                    <td class="p-tiny w-1/12">{{ pat.bed_Type }}</td>
                                    <td class="p-tiny w-1/6">
                                        <h5 class="text-sm leading-5 text-gray-700">Admission: 
                                            {{ pat.dateAdmitted | dateFormat }}</h5>
                                        <h5 class="text-sm leading-5 text-gray-700">Bed In: 
                                            {{ pat.bedDateIn | dateFormat }}</h5>
                                        <h5 class="text-sm leading-5 text-gray-700">Bed Out: 
                                            {{ pat.bedDateOut | dateFormat }}</h5>
                                    </td>
                                    <td class="p-tiny w-1/6">{{ pat.pmode }}</td>
                                    <td class="p-tiny w-1/12">
                                        <router-link 
                                            class="btn-sm text-xs btn-primary rounded" 
                                            :to="{ name: `pharmacy.dispense.create`, params: { patientID: pat.patientID, visitNO: pat.visitNo,}}">
                                                 <i class="fa fa-pills"></i> 
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>